export * from './admin.service';
import { AdminService } from './admin.service';
export * from './admin.serviceInterface';
export * from './auth.service';
import { AuthService } from './auth.service';
export * from './auth.serviceInterface';
export * from './categories.service';
import { CategoriesService } from './categories.service';
export * from './categories.serviceInterface';
export * from './competitions.service';
import { CompetitionsService } from './competitions.service';
export * from './competitions.serviceInterface';
export * from './countries.service';
import { CountriesService } from './countries.service';
export * from './countries.serviceInterface';
export * from './health.service';
import { HealthService } from './health.service';
export * from './health.serviceInterface';
export * from './internal.service';
import { InternalService } from './internal.service';
export * from './internal.serviceInterface';
export * from './lab.service';
import { LabService } from './lab.service';
export * from './lab.serviceInterface';
export * from './notifications.service';
import { NotificationsService } from './notifications.service';
export * from './notifications.serviceInterface';
export * from './permissions.service';
import { PermissionsService } from './permissions.service';
export * from './permissions.serviceInterface';
export * from './simpleLab.service';
import { SimpleLabService } from './simpleLab.service';
export * from './simpleLab.serviceInterface';
export * from './statistics.service';
import { StatisticsService } from './statistics.service';
export * from './statistics.serviceInterface';
export * from './statisticsAi.service';
import { StatisticsAiService } from './statisticsAi.service';
export * from './statisticsAi.serviceInterface';
export * from './teamCheck.service';
import { TeamCheckService } from './teamCheck.service';
export * from './teamCheck.serviceInterface';
export * from './users.service';
import { UsersService } from './users.service';
export * from './users.serviceInterface';
export * from './video.service';
import { VideoService } from './video.service';
export * from './video.serviceInterface';
export * from './videoScenes.service';
import { VideoScenesService } from './videoScenes.service';
export * from './videoScenes.serviceInterface';
export * from './videoStatus.service';
import { VideoStatusService } from './videoStatus.service';
export * from './videoStatus.serviceInterface';
export * from './videoUpload.service';
import { VideoUploadService } from './videoUpload.service';
export * from './videoUpload.serviceInterface';
export * from './websocket.service';
import { WebsocketService } from './websocket.service';
export * from './websocket.serviceInterface';
export * from './wiseIdAuth.service';
import { WiseIdAuthService } from './wiseIdAuth.service';
export * from './wiseIdAuth.serviceInterface';
export const APIS = [AdminService, AuthService, CategoriesService, CompetitionsService, CountriesService, HealthService, InternalService, LabService, NotificationsService, PermissionsService, SimpleLabService, StatisticsService, StatisticsAiService, TeamCheckService, UsersService, VideoService, VideoScenesService, VideoStatusService, VideoUploadService, WebsocketService, WiseIdAuthService];
